module.exports = __webpack_public_path__ + "img/a48e0d11bdf8453606af0db16496ffab.png";